import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { JobsService } from '../../common/services/jobs.service';
import { APIService } from '../../common/services/api.service';

import { JobsPage } from './jobsPage.model';
import { UserAccount, AccountType } from '../../common/models/account';

export const jobsPageResolver: ResolveFn<JobsPage> = async () => {
  const jobsService = inject(JobsService);
  const apiService = inject(APIService);

  const _jobs = jobsService.getJobs();
  const _isStaff = apiService.authenticatedData().then((userData?: UserAccount | null) => {
    return !!(userData?.accountType === AccountType.Staff);
  });

  apiService.processRequests();

  return {
    jobs: await _jobs,
    isStaff: await _isStaff,
  };
};
